const moderatBlack = {
    fontFamily: 'Moderat-Black',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(/fonts/Moderat-Black.woff2)'
  }
  
  const moderatLight = {
    fontFamily: 'Moderat-Light',
    fontWeight: '100',
    fontStyle: 'normal',
    src: 'url(/fonts/Moderat-Light.woff2)'
  }
  
  const moderatMedium = {
    fontFamily: 'Moderat-Medium',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(/fonts/Moderat-Medium.woff2)'
  }

  const fontFaceOverrides = {
    MuiCssBaseline: {
        '@global': {
          '@font-face': [moderatBlack, moderatMedium, moderatLight]
        }
      }
  }

  export {
      moderatBlack,
      moderatLight,
      moderatMedium,
      fontFaceOverrides
  }